<template lang="pug">
.generic-wrapper
  .container
    BackButton(name="CMSOverview")
    h1.title Alle Seiten
    .sub-headline Hier können Sie alle Seiten verwalten.
    
    .button-wrapper.margin-top
      b-field(grouped)    
        template(v-if="newPageType")
          b-radio(v-for="rootBlockModel in rootBlockModels" name="pageType" :native-value="rootBlockModel.uuid" v-model="newPageType") {{rootBlockModel.name}}
        
        b-input(placeholder="Name der neuen Seite" v-model="newPageName")
        
        b-button(type="is-primary" icon-left="plus" @click="createNewPage" v-if="newPageName") Seite erstellen

    b-tabs.margin-top(v-if="rootBlockModels" vertical v-model="activeTab" @input="(e) => setTabinURL(e)")
      b-tab-item(v-for="rootBlockModel in rootBlockModels" :label="rootBlockModel.name" :key="rootBlockModel.id")
        .card
          .main
            .top
              b-table(:data="blocks.filter( b => (b.pageType === rootBlockModel.uuid && b.name.toLowerCase().includes(filterName.toLowerCase())))"
                      default-sort-direction="desc"
                      default-sort="createdAt"
                      hoverable
                      @click="row => $router.push({ name: 'CMSBlockEdit', params: { id: row.id } })")
                b-table-column(field='name' label='Name' sortable, searchable)
                  template(#searchable)
                    b-input(v-model='filterName', @input="(e) => setFilterinURL(e)" placeholder='Suche...', icon='magnify')
                  template(v-slot='props')
                    | {{props.row.name}}
                b-table-column(field='pageType' label='Seitentyp' sortable, v-slot="props")
                  | {{rootBlockModels.length > 0 ? rootBlockModels.find(r => r.uuid === props.row.pageType).name : ''}}
                b-table-column(field='updatedAt' label='letzte Aktualisierung' sortable, v-slot="props")
                  | {{formatDate(props.row.updatedAt)}}
                b-table-column(field='createdAt' label='erstellt am' sortable, v-slot="props")
                  | {{formatDate(props.row.createdAt)}}
                b-table-column(field='active' label='Status' sortable, v-slot="props")
                  b-tag(v-if="props.row.active" type="is-success") Veröffentlicht
                  b-tag(v-else type="is-gray") Entwurf
                b-table-column(v-slot="props")
                  div
                    b-tooltip(label='Bearbeiten' type='is-secondary' position='is-bottom' :delay="1250")
                      b-button(icon-right="pencil", type="is-secondary" @click.stop="$router.push({ name: 'CMSBlockEdit', params: { id: props.row.id } })")
                    .spacer.sm.inline
                    b-tooltip(label='Klonen' type='is-secondary' position='is-bottom' :delay="1250")
                      b-button(icon-right="content-copy", type="is-secondary" @click.stop="openClonePageModal(props.row.id)")
                    .spacer.sm.inline
                    b-tooltip(label='Dauerhaft löschen' type='is-danger' position='is-bottom' :delay="1250")
                      b-button(icon-right="close", type="is-danger" @click.stop="deleteBlock(props.row)")
      b-tab-item(label="Spezial")
        .card
          .main
            .top
              b-table(:data="blocks.filter( b => blockModels.find(m => m.uuid === b.pageType) && blockModels.find(m => m.uuid === b.pageType).special)"
                      default-sort-direction="asc"
                      default-sort="createdAt"
                      hoverable
                      @click="row => $router.push({ name: 'CMSBlockEdit', params: { id: row.id } })")
                b-table-column(field='name' label='Name' sortable, v-slot="props")
                  | {{props.row.name}}
                b-table-column(field='pageType' label='Seitentyp' sortable, v-slot="props")
                  | {{(rootBlockModels.length > 0 && rootBlockModels.find(r => r.uuid === props.row.pageType)) ? rootBlockModels.find(r => r.uuid === props.row.pageType).name : ''}}
                b-table-column(field='updatedAt' label='letzte Aktualisierung' sortable, v-slot="props")
                  | {{formatDate(props.row.updatedAt)}}
                b-table-column(field='createdAt' label='erstellt am' sortable, v-slot="props")
                  | {{formatDate(props.row.createdAt)}}
                b-table-column(field='active' label='Status' sortable, v-slot="props")
                  b-tag(v-if="props.row.active" type="is-success") Veröffentlicht
                  b-tag(v-else type="is-gray") Entwurf
                b-table-column(v-slot="props")
                  div
                    b-tooltip(label='Bearbeiten' type='is-secondary' position='is-bottom' :delay="1250")
                      b-button(icon-right="pencil", type="is-secondary" @click.stop="$router.push({ name: 'CMSBlockEdit', params: { id: props.row.id } })")
  b-modal(v-model='showCloneModal', has-modal-card='', trap-focus='', :destroy-on-hide='false')
    template(#default='props')
      .modal-card(style='width: auto')
        header.modal-card-head
          p.modal-card-title Seite klonen
          button.delete(type='button', @click="showCloneModal = false")
        section.modal-card-body
          b-field(label='Name')
            b-input(type='name', v-model='newPageName', placeholder='Seitenname ..')
        footer.modal-card-foot
          b-button(label='Abbrechen', @click="showCloneModal = false")
          b-button(label='Klonen', type='is-primary' :disabled="newPageName === ''", @click="clonePage")



</template>

<script>
import { v4 as uuidv4 } from 'uuid';
import { DateTime } from 'luxon';

export default {
  data() {
    return {
      filterName: '',
      activeTab: null,
      cloneId: null,
      showCloneModal: false,
      newPageName: "",
      newPageType: null,
      rootBlockModels: []
    };
  },
  computed: {
    blockModels() {
      return this.$store.state.blockModels.all;
    },
    blocks() {
      return this.$store.state.blocks.all;
    }
  },
  methods: {
    setTabinURL(e) {
      this.$router.replace({ query: {activeTab: e, filter: this.filterName} })
    },
    setFilterinURL(e) {
      this.$router.replace({ query: {filter: e, activeTab: this.activeTab} })
    },
    async clonePage() {
      this.showCloneModal = false;
      await this.$store.dispatch('blocks/clone', { cloneId: this.cloneId, name: this.newPageName });
      this.$store.dispatch("blocks/findAll");
    },
    openClonePageModal(id) {
      this.cloneId = id;
      this.showCloneModal = true;
    },
    async createNewPage() {
      const key = uuidv4();
      try {
        const newPage = await this.$store.dispatch("blocks/create", { name:         this.newPageName,
                                                                      pageType:     this.newPageType,
                                                                      content:      {...this.rootBlockModels.find(r => r.uuid === this.newPageType),
                                                                                      key
                                                                                    }, // content as well as this is the starting point
                                                                      draftContent: {...this.rootBlockModels.find(r => r.uuid === this.newPageType),
                                                                                      key
                                                                                    }
                                                                    });
        this.$router.push({name: 'CMSBlockEdit', params: {id: newPage.id}});
      } catch(e) {
        this.$store.dispatch(
              "common/showError",
              "Der Name ist bereits vergeben." + e
            );
      }
    },
    deleteBlock(row) {
      this.$buefy.dialog.confirm({
        title: "Seite löschen",
        message: `Sind Sie sicher, dass Sie diese Seite <b>${row.name}</b> löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.`,
        confirmText: "Seite löschen",
        cancelText: "Abbrechen",
        type: "is-danger",
        hasIcon: true,
        onConfirm: async () => {
          try {
            await this.$store.dispatch("blocks/delete", { id: row.id });
          } catch (e) {
            this.$store.dispatch(
              "common/showError",
              "Seite konnte nicht gelöscht werden."
            );
          }
        }
      });
    },
    formatDate(d) {
      const dt = DateTime.fromISO(d);
      return dt.setLocale('de')
        .toFormat("dd. LLL. yy")
    }
  },
  async mounted() {
    this.$store.dispatch("blocks/findAll");
    const rootBlockModels = await this.$store.dispatch("blockModels/findAll");
    this.rootBlockModels = rootBlockModels.filter(b => b.root);
    this.newPageType = this.rootBlockModels[0].uuid;

    this.$nextTick(() => {
      if (this.$route.query.activeTab !== undefined) {
        this.activeTab =  +this.$route.query.activeTab;
      } else {
        this.activeTab = 0;
      }
      if (this.$route.query.filter !== undefined) {
        this.filterName = this.$route.query.filter;
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.icon-name {
  margin-left: $sm-space;
}
</style>